import { buildVersion } from "../build";

export interface Config {
    env: "prod" | "dev" | "local" | "test";
    serviceHost: string;
    envTitle?: string;
    buildVersion: string;
    firebaseAuthEmulatorHost?: string;
    demoOrgId?: string;
}

export enum Environment {
    prod = "prod",
    dev = "dev",
    local = "local",
    test = "test",
}

const defaultConfig: Config = {
    env: "prod",
    serviceHost: "https://prod.api.tekkr.io",
    buildVersion,
    demoOrgId: "68b5c43627575097c4e6e09d",
};

const envConfig: Partial<Record<Environment, Partial<Config> & Pick<Config, "env">>> = {
    [Environment.local]: {
        env: "local",
        serviceHost: "http://localhost:8080",
        envTitle: "LOCAL",
    },
    [Environment.dev]: {
        env: "dev",
        serviceHost: "https://dev.api.tekkr.io",
        envTitle: "DEV",
    },
    [Environment.test]: {
        env: "test",
        firebaseAuthEmulatorHost: process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST,
        serviceHost: process.env.REACT_APP_BACKEND_HOST,
        envTitle: "TEST",
    },
};

const devHosts = ["tekkr-dev", "onboarding.tekkr.io", "projects-dev", "app-dev"];

export const config: Config = (() => {
    let env = Environment.prod;
    if (window.location.host.includes("localhost")) {
        env = Environment.local;
    } else if (devHosts.find((host) => window.location.host.includes(host))) {
        env = Environment.dev;
    }

    if (process.env.REACT_APP_TEKKR_TEST) {
        env = Environment.test;
    }
    const overrides = envConfig[env];
    return {
        ...defaultConfig,
        ...overrides,
    };
})();
